import { Box, BoxProps } from '@chakra-ui/react';
import { Input, InputProps } from 'components/UI';
import { SearchIcon } from '@chakra-ui/icons';

export type SearchProps = InputProps & {
  containerProps?: BoxProps;
};

const Search = ({ containerProps, ...props }: SearchProps) => (
  <Box {...containerProps}>
    <Input
      isClear
      rightComponent={<SearchIcon color="gray.400" fontSize={['sm', 'md']} />}
      bgColor="white"
      _hover={{
        bgColor: 'white',
      }}
      _focus={{
        bgColor: 'white',
      }}
      fontSize={['sm', 'md']}
      {...props}
    />
  </Box>
);

export default Search;
